export default (function (value, separator) {
  if (separator === void 0) {
    separator = ',';
  }
  if (Array.isArray(value)) {
    return value.join(separator);
  }
  if (typeof value === 'string') {
    return value.replace(/,|\|/gi, separator);
  }
  return '';
});